import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import Onboarding2022App from 'bundles/onboarding-2022/components/Onboarding2022App';
import NotFound from 'bundles/phoenix/components/NotFound';

const NonSurveyOnboarding = loadOnRoute(
  () => import('bundles/onboarding-2022/components/non-survey/NonSurveyOnboarding')
);
const OnboardingPageDelegator = loadOnRoute(
  () => import('bundles/onboarding-2022/components/survey/OnboardingPageDelegator')
);

export default (
  <Route path="/" component={Onboarding2022App}>
    <Route path="onboarding-2022/:questionId" getComponent={NonSurveyOnboarding} />
    <Route path="onboarding-2022" getComponent={OnboardingPageDelegator} />
    <Route path="onboarding/:questionId" getComponent={NonSurveyOnboarding} />
    <Route path="onboarding" getComponent={OnboardingPageDelegator} />
    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </Route>
);
